module.exports = __webpack_public_path__ + "img/ic-9.4cbc451.svg";